import { Directive } from '@angular/core';

@Directive({
  selector: '[efFormFieldSuffix]',
  standalone: true,
})
export class EfFormFieldSuffixDirective {}
